module.exports = __webpack_public_path__ + "img/ingredient-cost-icon.53ba4b1f.jpg";